import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { availabilityShape, bibShape, checkedOutItemShape, holdItemShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';

import { HOLD_STATUS_TYPES } from 'app/constants/HoldsConstants';
import accountShape from 'app/shapes/accountShape';
import { checkoutTransactionsShape } from 'app/shapes/borrowing';
import DigitalHoldButton from './DigitalHoldButton';
import CheckedOutDropdown from './CheckedOutDropdown';
import CheckoutButton from './CheckoutButton';

export default class DigitalAccessButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
    this.modalKey = `digital-access-modal-${this.props.bib.get('id')}`;
  }

  handleOpen() {
    const { bib, digitalFormats, bibsActions, modalActions } = this.props;
    const openModal = () => {
      modalActions.openModal(this.modalKey, { accountRequired: true });
    };

    if (!digitalFormats.size) {
      bibsActions.fetchDigitalFormats({
        metadataId: bib.get('id'),
        postSuccess: openModal
      });
    } else {
      openModal();
    }
  }

  handleClose() {
    this.props.modalActions.closeModal(this.modalKey);
  }

  render() {
    const {
      bib,
      realtimeAvailability,
      holdItem,
      checkoutItem,
      currentAccount,
      checkoutTransactions,
      holdsTransactions,
      bibsActions,
      holdActions,
      shelfActions,
      modalActions,
      checkoutActions,
      digitalFormats,
      isLoading
    } = this.props;

    const hasItemLevelHoldableItems = bib.getIn(['policy', 'itemLevelHoldableItems']);
    const isDigitalHoldReady = holdItem && holdItem.get('status') === HOLD_STATUS_TYPES.READY_FOR_PICKUP;
    const availability = realtimeAvailability || bib.get('availability');

    if (checkoutItem && !hasItemLevelHoldableItems && currentAccount) {
      return (
        <CheckedOutDropdown
          bib={bib}
          checkoutTransactions={checkoutTransactions}
          checkoutActions={checkoutActions}
          bibsActions={bibsActions}
          modalActions={modalActions}
          digitalFormats={digitalFormats}
          currentAccount={currentAccount}
          checkoutItem={checkoutItem}
          shelfActions={shelfActions}
          isLoading={isLoading}
          trackCheckoutConsumeAccess={this.props.trackCheckoutConsumeAccess}
          trackCheckoutConsumeDownload={this.props.trackCheckoutConsumeDownload}
        />
      );
    }

    if (isDigitalHoldReady || availability.get('status') === 'AVAILABLE') {
      return (
        <CheckoutButton
          bib={bib}
          checkoutTransactions={checkoutTransactions}
          checkoutActions={checkoutActions}
          digitalFormats={digitalFormats}
          currentAccount={currentAccount}
          handleOpen={this.handleOpen}
          handleClose={this.handleClose}
          isLoading={isLoading}
          modalKey={this.modalKey}
        />
      );
    }

    return (
      <DigitalHoldButton
        bib={bib}
        currentAccount={currentAccount}
        holdsTransactions={holdsTransactions}
        holdActions={holdActions}
        digitalFormats={digitalFormats}
        handleOpen={this.handleOpen}
        handleClose={this.handleClose}
        isLoading={isLoading}
        modalKey={this.modalKey}
      />
    );
  }
}

DigitalAccessButton.propTypes = {
  bib: bibShape.isRequired,
  isLoading: PropTypes.bool,
  currentAccount: accountShape,
  checkoutItem: checkedOutItemShape,
  holdItem: holdItemShape,
  realtimeAvailability: availabilityShape,
  checkoutTransactions: checkoutTransactionsShape.isRequired,
  holdsTransactions: ImmutablePropTypes.map.isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  checkoutActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  digitalFormats: ImmutablePropTypes.list,
  trackCheckoutConsumeAccess: PropTypes.func,
  trackCheckoutConsumeDownload: PropTypes.func
};
